export function getSnakeFromAld(ald) {
    if (ald.account_like_type === 'site') {
        return {
            site_id: ald.account_like_id,
        };
    }
    else if (ald.account_like_type === 'channel') {
        return {
            channel_id: ald.account_like_id,
        };
    }
    else {
        return {
            advertiser_account_id: ald.account_like_id,
        };
    }
}
export function getAldFromAwd(awd) {
    const advertiser_account_id = awd.advertiser_account_id ?? null;
    if (advertiser_account_id) {
        return {
            account_like_type: 'advertiser_account',
            account_like_id: advertiser_account_id,
        };
    }
    return {
        account_like_type: awd.workspace_type,
        account_like_id: awd.workspace_id,
    };
}
//# sourceMappingURL=advertiserAccount.js.map